import Api from "../../../util/Api";

export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-redo-alt"></i>',
                title: "Beküldés",
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'postSubmissionEvidences'
            }
        ],
        searchFields: [
            {
                name: "doctorId",
                label: "Orvos",
                formSize: 3,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllDoctorForEesztReport,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "documentCreatedOnFrom",
                label: "Dokumentum létrehozása (tól)",
                formSize: 3,
                formType: "dateMonth"
            },
            {
                name: "documentCreatedOnTo",
                label: "Dokumentum létrehozása (ig)",
                formSize: 3,
                formType: "dateMonth"
            }
        ],
        headerFields: [
            {
                name: "doctorName",
                label: "Orvos",
                visibility: true,
                sort: true
            },
            {
                name: "evidenceCreatedMonth",
                label: "Dokumentum létrehozása (hónap)",
                visibility: true,
                slot_name: "dateMonthFormat",
                sort: true
            },
            {
                name: "evidenceCount",
                label: "Dokumentumok száma",
                visibility: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],

        logHeaderFields: [
            {
                name: "patientName",
                label: "Páciens",
                visibility: true
            },
            {
                name: "evidenceType",
                label: "Ambuláns lap típusa",
                visibility: true
            },
            {
                name: "evidenceCreatedOn",
                label: "Ambuláns lap létrehozva",
                slot_name: "datetime_format",
                visibility: true
            },
            {
                name: "logText",
                label: "Napló",
                visibility: true
            },
            {
                name: "createdOn",
                label: "Napló létrehozva",
                slot_name: "created_on_format",
                visibility: true
            }
        ]
    }
}
